import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';

import reducer, { initialState } from './reducer';
import actionsFactory from './reducer/actions';

const initialContext = {
  ...initialState,
  actions: actionsFactory(() => {}),
};

const AccountInfoFormContext = createContext(initialContext);
const useAccountInfoFormContext = () => useContext(AccountInfoFormContext);

function AccountInfoFormContextProvider({ children, account }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => actionsFactory(dispatch), [dispatch]);

  const contextValue = { ...state, actions };

  useEffect(() => {
    actions.setAccount(account);
  }, [account, actions]);

  return (
    <AccountInfoFormContext.Provider value={contextValue}>
      {children}
    </AccountInfoFormContext.Provider>
  );
}

export { useAccountInfoFormContext, AccountInfoFormContextProvider };
